const hideHeaderFooter = () => ({ type: 'HIDE' });
const showHeaderFooter = () => ({ type: 'SHOW' });

export { hideHeaderFooter, showHeaderFooter };
